import { useMemo, useState } from 'react';
import { DateFormats, localFormat } from '../../../../helpers/date-helpers';
import Style from './RecentUpdatesColumn.module.scss';
import { Tooltip } from 'uikit/tooltip/tooltip.component';
import { Trans, useTranslation } from 'react-i18next';
import { PatientChangesEvent } from '../../../../services/api/api-client';
import { useGetPatientChangesInfoQuery } from '../../../../services/api/api-client/PatientQuery';
import { LocalizedResourceDictionaryKeys } from '../../../../application/localisation/i18next';
import { Loading } from 'uikit/suspense/Loading';

export const RecentUpdatesColumn = (props: { date: Date; patientId: string }) => {
  const { date, patientId } = props;
  const { t } = useTranslation();
  const [isHover, setHover] = useState(false);
  const changesInfoRequest = useGetPatientChangesInfoQuery(patientId, { suspense: false, enabled: isHover });

  const changesData = useMemo(() => {
    return (
      <div className={Style.tooltipContainer}>
        <Loading
          renderChildren={false}
          loading={changesInfoRequest.isInitialLoading}
          testId={'recent-updates'}
          loaderClassName={Style.loading}
        >
          {changesInfoRequest.data ? (
            <>
              <div>
                <Trans
                  i18nKey={'Dashboard.PatientTable.RecentUpdate.Person'}
                  values={{ value: changesInfoRequest.data.modifyBy || '' }}
                >
                  <span className={Style.tooltipHeaderText}>
                    {t('Dashboard.PatientTable.RecentUpdate.Person', { value: changesInfoRequest.data.modifyBy })}
                  </span>
                </Trans>
              </div>
              <div>
                <Trans
                  i18nKey={
                    `Dashboard.PatientTable.RecentUpdate.Events.${
                      PatientChangesEvent[changesInfoRequest.data.modifyEvent]
                    }` as LocalizedResourceDictionaryKeys
                  }
                  values={{ value: changesInfoRequest.data.additionalInfo || '' }}
                >
                  <span className={Style.tooltipHeaderText} />
                </Trans>
              </div>
            </>
          ) : (
            <span>{t('Common_Error')}</span>
          )}
        </Loading>
      </div>
    );
  }, [changesInfoRequest.isInitialLoading, changesInfoRequest.data, t]);

  return (
    <Tooltip hostStyles={Style.tooltipHost} tooltipContent={changesData}>
      <div className={Style.container} onMouseEnter={() => setHover(true)}>
        <div className={Style.date}>{localFormat(date, DateFormats.longDate)}</div>
        <div className={Style.time}>{localFormat(date, DateFormats.timeOnly)}</div>
      </div>
    </Tooltip>
  );
};
